import { Theme } from '@mui/material';

export const getCheckboxOptions = ({ palette }: Theme) => {
  const checkboxComponents = {
    styleOverrides: {
      root: () => {
        return {
          width: '24px',
          height: '24px',
          color: palette.checkbox.border,
          '&.Mui-checked': {
            color: palette.checkbox.checked,
          },
        };
      },
    },
  };

  return { checkboxComponents };
};
